/* ============================================================
   Özel Paketler — Sepet drawer paket modülü (Faz 3a)
   ------------------------------------------------------------
   GoCart drawer'ı (minified bundle) render ETTİKTEN SONRA çalışan
   EK (additive) bir overlay. Bundle'a / checkout'a dokunmaz.

   - #fos-cart-packages-data JSON'undan combo tanımlarını okur.
   - Drawer her render olduğunda /cart.js'i çekip satırları bileşenlerle
     (ürün id'siyle) eşleştirir.
   - Combo tüm bileşenleriyle sepetteyse  → "avantajlı paket" rozeti.
   - Bazı bileşenleri eksikse             → "paketi tamamla" dürtüsü
     (tek-bedenli eksik → direkt Ekle; çok-bedenli → satır içi beden).
   - Ekledikten sonra window.goCart.fetchAndOpenCart() ile drawer yenilenir;
     observer tekrar çalışıp modülü günceller.

   Fiyat ilkesi: avantaj = Σ(bileşen fiyatı) − tier.total_price (CANLI).
   ============================================================ */
(function () {
  'use strict';

  /* Paket adları çoğunlukla marka/İngilizce adlardır: DAILY FIT gibi standart
     Latin büyük harf kullanır (tr kuralıyla "DAİLY FİT" olurdu). Türkçe harf
     taşıyan adlar (Kış İkilisi) Türkçe kuralla büyür: "KIŞ İKİLİSİ". */
  function packageNameUpper(value) {
    var s = String(value || '');
    return /[çğıöşüÇĞİÖŞÜ]/.test(s) ? s.toLocaleUpperCase('tr') : s.toUpperCase();
  }

  /* i18n: metinler theme.liquid'deki window.fosI18n adasından (locales/*.json)
     gelir; ada yoksa Türkçe fallback. __X__ yer tutucularını tt() doldurur. */
  var I18N = window.fosI18n || {};
  function tt(key, fallback, repl) {
    var s = (typeof I18N[key] === 'string' && I18N[key]) ? I18N[key] : fallback;
    if (repl) {
      for (var k in repl) { s = s.split('__' + k + '__').join(repl[k]); }
    }
    return s;
  }

  var PKGS = null;
  /* Tarihli paket (Kasım) bitiş anı geçtiyse sayfa yenilenmeden de yok
     sayılır: veri adası sayfa yüklenirken basıldığı için 23:59'u açık
     sekmede geçiren müşteriye kapanmış paket önerilmesin. Kasa da o an
     kapanıyor. */
  function packages() {
    var now = Date.now();
    return loadPackages().filter(function (pkg) {
      return !pkg.endsAt || pkg.endsAt > now;
    });
  }

  function loadPackages() {
    if (PKGS !== null) {
      return PKGS || [];
    }
    var el = document.getElementById('fos-cart-packages-data');
    if (!el) {
      PKGS = false;
      return [];
    }
    try {
      PKGS = JSON.parse(el.textContent);
      if (Array.isArray(PKGS)) {
        PKGS.forEach(function (pkg) {
          pkg.name = packageNameUpper(pkg.name);
        });
      }
    } catch (e) {
      PKGS = false;
    }
    return PKGS || [];
  }

  function money(cents) {
    return Math.round(cents / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' TL';
  }

  var DRAWER_CONTENT = '.go-cart-drawer__content';
  var lastSig = '';
  var injecting = false;
  /* Son analyze() çalışmasında tamamlanmış kombinlere harcanan üniteler
     (satır key'i → adet). Sepetten açılan builder'lar da bunları kilitlemez —
     Daily Fit'in şapkası, Cap Set builder'ında "sepette" diye gelmez.
     Sayaçlar variant DEĞİL satır bazlıdır: aynı varyant sepette birden fazla
     satırda durabiliyor (builder aynı bedeni iki slota koyduğunda) ve variant
     bazlı sayım o satırların ünitelerini iki kez sayıyordu. */
  var lastComboUsed = {};
  var lastPackageUsed = {};

  function cartSignature(cart) {
    return cart.items
      .map(function (i) { return i.variant_id + 'x' + i.quantity; })
      .join('|');
  }

  function analyzeCombo(pkg, cart, avail) {
    return pkg.slotMode ? analyzeComboSlots(pkg, cart, avail) : analyzeComboFixed(pkg, cart);
  }

  /* ----------------------------------------------------------
     GERÇEK TAHSİS (indirim Function'ından).

     `fos-package-discounts` Function'ı kampanya başına ayrı candidate emit
     eder ve mesajı kampanya adıdır ("FULL FIT PAKETİ"). Shopify bunu satır
     bazında tahsis eder — üstelik bir satırın yalnız BİR kısmı indirimliyse
     satırı böler, dolayısıyla her satır en fazla tek kampanyaya aittir.
     Sonuç: hangi satırın hangi pakete gittiği /cart.js'te YAZILIDIR; tahmin
     etmeye gerek yok. Tema bunu okuyup collapse ettiği satırları gerçeğe
     hizalar — yoksa paket satırına gizlenen tee ile Function'ın indirimlediği
     tee ayrışıp sepette 1.650 → 1.187,16 gibi orantısal ara fiyatlar kalıyor.
     Function kapalıysa alloc boş döner ve sezgisel seçim yürürlükte kalır.
     ---------------------------------------------------------- */
  /* "Haftalık Çorap Paketi" ↔ "HAFTALIK ÇORAP PAKETİ" eşleşsin: büyük harf +
     İ/I sadeleştirmesi + sondaki "PAKETİ" ekini at. */
  function pkgKey(value) {
    return String(value || '')
      .toUpperCase()
      .split('İ').join('I')
      .replace(/\s+PAKETI$/, '')
      .trim();
  }

  function lineAllocations(line) {
    var raw = line.line_level_discount_allocations || line.discounts || [];
    return raw
      .map(function (a) {
        var title = a.discount_application ? a.discount_application.title : a.title;
        return { key: pkgKey(title), amount: a.amount || 0 };
      })
      .filter(function (a) { return a.key; });
  }

  function allocationsByPackage(cart) {
    var byPkg = {};
    cart.items.forEach(function (line) {
      var allocs = lineAllocations(line);
      // iki kampanya aynı satırdaysa (beklenmez — Shopify böyle satırları
      // böler) sahiplik belirsizdir, satırı hiçbir pakete yazma
      if (allocs.length !== 1) { return; }
      var a = allocs[0];
      if (!byPkg[a.key]) { byPkg[a.key] = { lines: [], amount: 0 }; }
      byPkg[a.key].lines.push(line);
      byPkg[a.key].amount += a.amount;
    });
    return byPkg;
  }

  /* Tamamlanmış kombin satırını gerçek tahsise hizala: hangi satırlar
     collapse edilecek, çapa ve avantaj ne. Kampanya sepette bulunamazsa
     (Function kapalı, ad eşleşmedi, slot sayısı tutmadı) sezgisel sonuç
     olduğu gibi kalır. */
  function applyActualAllocation(row, byPkg) {
    var actual = byPkg[pkgKey(row.pkg.name)];
    if (!actual || actual.lines.length !== row.lines.length) { return; }
    row.lines = actual.lines.map(function (line) {
      return {
        comp: { id: line.product_id, title: line.product_title || line.title, image: line.image },
        line: line
      };
    });
    row.anchor = actual.lines.reduce(function (s, l) { return s + l.price; }, 0);
    row.filledTotal = row.anchor;
    row.advantage = actual.amount;
    row.collapsible = actual.lines.every(function (l) { return l.quantity === 1; });
  }

  /* Sabit bileşenli combo (geriye dönük — şu an hiçbir paket kullanmıyor). */
  function analyzeComboFixed(pkg, cart) {
    // her ürünün İLK sepet satırı
    var lineOf = {};
    cart.items.forEach(function (i) { if (!lineOf[i.product_id]) { lineOf[i.product_id] = i; } });

    var present = [];
    var missing = [];
    var lines = [];
    pkg.components.forEach(function (c) {
      var line = lineOf[c.id];
      if (line) { present.push(c); lines.push({ comp: c, line: line }); }
      else { missing.push(c); }
    });
    if (!present.length) {
      return null; // bu combo sepetle alakasız
    }
    var complete = missing.length === 0;
    var anchor = pkg.components.reduce(function (s, c) { return s + c.price; }, 0);
    // collapse (tek paket satırı) yalnız her bileşen TAM 1 adetse — qty>1 belirsiz.
    var collapsible = complete && lines.every(function (x) { return x.line.quantity === 1; });
    return {
      pkg: pkg,
      slotMode: false,
      missing: missing,
      missingCount: missing.length,
      filledTotal: lines.reduce(function (s, x) { return s + x.line.price; }, 0),
      lines: lines,
      complete: complete,
      collapsible: collapsible,
      anchor: anchor,
      advantage: anchor - pkg.totalCents
    };
  }

  /* Slot-bazlı combo (Daily/Full Fit, Space Bag): her slot bir koleksiyon,
     sabit ürün YOK. Her slotu, `avail`de hâlâ payı olan (aktif volume
     kademesine veya önceki bir combo'ya "harcanmamış") İLK sepet satırı
     doldurur. Combo TAMAMSA kullandığı üniteleri avail'den düşer — böylece
     aynı ürün iki pakete birden sayılmaz. */
  function analyzeComboSlots(pkg, cart, avail) {
    var localUsed = {};
    var slotResults = pkg.slots.map(function (slot) {
      var ids = {};
      slot.qualifyingIds.forEach(function (id) { ids[id] = true; });
      /* Satır seçimi SEZGİSELDİR (en eski eşleşen satır) ve yalnız indirim
         Function'ı çalışmadığında (kapalı/ kurulmamış) geçerlidir. Function
         çalışıyorsa tamamlanmış kombinin satırları `applyActualAllocation`
         ile GERÇEK indirim tahsisinden yeniden yazılır — sıra tahminine
         güvenmeyiz: /cart.js en yeni satırı önce döner, Function ekleme
         sırasıyla tarar ve indirim satırları BÖLDÜĞÜ için iki sıra her zaman
         birbirinin tersi bile olmuyor (2026-07-24 hata raporu). */
      var matches = cart.items.filter(function (i) {
        var used = localUsed[i.key] || 0;
        return ids[i.product_id] && (avail[i.key] || 0) - used > 0;
      });
      var line = matches.length ? matches[matches.length - 1] : null;
      if (line) { localUsed[line.key] = (localUsed[line.key] || 0) + 1; }
      return { slot: slot, line: line };
    });
    var filled = slotResults.filter(function (s) { return s.line; });
    if (!filled.length) {
      return null; // bu combo sepetle alakasız
    }
    var complete = filled.length === slotResults.length;
    // NOT: tüketim burada YAPILMAZ — analiz saf bir "prob"dur. Üniteleri
    // yalnız greedy tahsiste kazanan aday tüketir (analyze() içinde).
    var anchor = filled.reduce(function (s, x) { return s + x.line.price; }, 0);
    var collapsible = complete && slotResults.every(function (s) { return s.line.quantity === 1; });
    var lines = filled.map(function (x) {
      return {
        comp: { id: x.line.product_id, title: x.line.product_title || x.line.title, image: x.line.image },
        line: x.line
      };
    });
    return {
      pkg: pkg,
      slotMode: true,
      slotResults: slotResults,
      missingCount: slotResults.length - filled.length,
      filledTotal: anchor,
      lines: lines,
      complete: complete,
      collapsible: collapsible,
      anchor: anchor,
      advantage: anchor - pkg.totalCents
    };
  }

  /* Volume: setteki (qualifyingIds) ürünleri say, kademeyi bul.
     `used` (satır key'i → adet): TAMAMLANMIŞ kombinlere harcanmış üniteler —
     sayıma GİRMEZ. Daily Fit'in şapkası Cap Set ilerlemesini/önerisini
     beslemez (2026-07-10 kullanıcı kuralı: kampanyalar çakışmasın). */
  function tierTotal(tier, prices) {
    if (!tier.freeQuantity) { return tier.total; }
    var selected = prices.slice(0, tier.qty);
    while (selected.length < tier.qty) {
      selected.push(prices[prices.length - 1] || 0);
    }
    return selected.slice(0, Math.max(0, tier.qty - tier.freeQuantity))
      .reduce(function (sum, price) { return sum + price; }, 0);
  }

  function analyzeVolume(pkg, cart, used) {
    var ids = {};
    pkg.qualifyingIds.forEach(function (id) { ids[id] = true; });
    var units = [];
    var count = 0;
    cart.items.forEach(function (i) {
      if (!ids[i.product_id]) { return; }
      var q = i.quantity - (used && used[i.key] ? used[i.key] : 0);
      if (q <= 0) { return; }
      count += q;
      for (var k = 0; k < q; k++) { units.push(i.price); }
    });
    if (!count) {
      return null;
    }
    var tiers = pkg.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
    if (!tiers.length) {
      return null;
    }

    // Gerçek fiyatlar, en pahalıdan ucuza. Avantaj = kademenin kapsadığı
    // ürünlerin gerçek toplamı (çapa) − tier.total. Aktif kademe için tüm
    // slotlar sepette → gerçek. Sonraki kademe için EKSİK slotlar sepetteki
    // EN UCUZ qualifying ürünün fiyatıyla öngörülür (gerçek fiyat, tutucu
    // tahmin — asla koda gömülü değil). Negatifse gösterilmez.
    var sorted = units.slice().sort(function (a, b) { return b - a; });
    var refUnit = sorted[sorted.length - 1] || 0;
    function advAt(t) {
      var anchor = 0;
      for (var i = 0; i < t.qty; i++) {
        anchor += (i < sorted.length) ? sorted[i] : refUnit;
      }
      return anchor - tierTotal(t, sorted);
    }

    var active = null;
    var next = null;
    tiers.forEach(function (t) {
      if (count >= t.qty) { active = t; }
      else if (!next) { next = t; }
    });

    // Müşterinin ŞU ANKİ ödemesi: aktif kademe varsa kademe fiyatı + kademe
    // dışında kalan (en ucuz) ünitelerin gerçek toplamı; yoksa hepsinin
    // gerçek toplamı. Öneri skorunda "markaya ek ciro" bundan türetilir.
    var allTotal = units.reduce(function (s, p) { return s + p; }, 0);
    var currentOutlay = allTotal;
    if (active) {
      var extra = sorted.slice(active.qty).reduce(function (s, p) { return s + p; }, 0);
      currentOutlay = tierTotal(active, sorted) + extra;
    }

    return {
      pkg: pkg,
      volume: true,
      idSet: ids,
      count: count,
      tiers: tiers,
      firstQty: tiers[0].qty,
      maxQty: tiers[tiers.length - 1].qty,
      active: active,
      activeAdv: active ? advAt(active) : 0,
      next: next,
      nextAdv: next ? advAt(next) : 0,
      nextTotal: next ? tierTotal(next, sorted) : 0,
      currentOutlay: currentOutlay
    };
  }

  /* Greedy tahsis probu: tahsis edilmemiş (avail) ünitelerle bu hacim
     paketinin ulaşabildiği EN YÜKSEK kademe + avantajı + alacağı üniteler.
     Kademe kapsamına en pahalı üniteler girer (avantaj hesabıyla aynı
     varsayım). Tüketim YAPMAZ — kazanan adayın ünitelerini analyze() düşer. */
  function volumeClaimProbe(pkg, cart, avail) {
    var ids = {};
    pkg.qualifyingIds.forEach(function (id) { ids[id] = true; });
    var units = [];
    cart.items.forEach(function (i) {
      if (!ids[i.product_id]) { return; }
      var q = avail[i.key] || 0;
      for (var k = 0; k < q; k++) { units.push({ line: i, price: i.price }); }
    });
    if (!units.length) { return null; }
    var tiers = pkg.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
    var active = null;
    tiers.forEach(function (t) { if (units.length >= t.qty) { active = t; } });
    if (!active) { return null; }
    units.sort(function (a, b) { return b.price - a.price; });
    var take = units.slice(0, active.qty);
    var anchor = 0;
    take.forEach(function (u) { anchor += u.price; });
    return { tier: active, adv: anchor - tierTotal(active, take.map(function (u) { return u.price; })), take: take };
  }

  /* ----------------------------------------------------------
     Kasa simülasyonu — tools/fos-package-discounts fonksiyonunun greedy
     tahsisinin aynası. Her turda tahsis edilmemiş ünitelerle EN BÜYÜK
     indirimi veren paket kazanır, paket başına tek hak, eşitlikte önce
     denenen (kombinler, sonra hacim). Kasım önerilerindeki bütün tutarlar
     ("sepetin 950 TL azalsın", "+2.000 TL") buradan çıkar; hiçbiri elle
     yazılmaz. Fonksiyon değişirse burası da değişir.

     Ünite: { pid, price } sepet satırından; { coll, price } "eklersen ne
     olur" denemesi — o koleksiyonun slotlarına/hacmine uyar.
     ---------------------------------------------------------- */
  function idSet(list) {
    var set = {};
    (list || []).forEach(function (id) { set[id] = true; });
    return set;
  }

  function unitFits(unit, ids, collectionHandle) {
    return unit.coll ? unit.coll === collectionHandle : !!ids[unit.pid];
  }

  function cartUnits(cart) {
    var units = [];
    cart.items.forEach(function (i) {
      for (var k = 0; k < i.quantity; k++) { units.push({ pid: i.product_id, price: i.price }); }
    });
    return units;
  }

  function simulate(units) {
    var pkgs = packages();
    var combos = pkgs.filter(function (p) { return p.kind === 'combo' && p.slotMode; });
    var vols = pkgs.filter(function (p) { return p.kind === 'volume' || p.kind === 'bxgy'; });
    var avail = units.map(function () { return true; });
    var claimed = {};
    var winners = [];
    var total = units.reduce(function (sum, u) { return sum + u.price; }, 0);

    for (;;) {
      var best = null;
      combos.forEach(function (pkg) {
        if (claimed[pkg.handle]) { return; }
        var picked = [];
        var ok = pkg.slots.every(function (slot) {
          var ids = slot._ids || (slot._ids = idSet(slot.qualifyingIds));
          for (var i = 0; i < units.length; i++) {
            if (avail[i] && picked.indexOf(i) === -1 && unitFits(units[i], ids, slot.collectionHandle)) {
              picked.push(i);
              return true;
            }
          }
          return false;
        });
        if (!ok) { return; }
        var anchor = picked.reduce(function (sum, i) { return sum + units[i].price; }, 0);
        var discount = anchor - pkg.totalCents;
        if (discount > 0 && (!best || discount > best.discount)) {
          best = { pkg: pkg, units: picked, discount: discount };
        }
      });
      vols.forEach(function (pkg) {
        if (claimed[pkg.handle]) { return; }
        var ids = pkg._ids || (pkg._ids = idSet(pkg.qualifyingIds));
        var idx = [];
        units.forEach(function (u, i) {
          if (avail[i] && unitFits(u, ids, pkg.collectionHandle)) { idx.push(i); }
        });
        var tier = null;
        pkg.tiers.forEach(function (t) {
          if (t.qty > 1 && idx.length >= t.qty && (!tier || t.qty > tier.qty)) { tier = t; }
        });
        if (!tier) { return; }
        idx.sort(function (a, b) { return (units[b].price - units[a].price) || (a - b); });
        idx = idx.slice(0, tier.qty);
        var prices = idx.map(function (i) { return units[i].price; });
        var anchor = prices.reduce(function (sum, x) { return sum + x; }, 0);
        var discount = anchor - tierTotal(tier, prices);
        if (discount > 0 && (!best || discount > best.discount)) {
          best = { pkg: pkg, units: idx, discount: discount };
        }
      });
      if (!best) { break; }
      claimed[best.pkg.handle] = true;
      best.units.forEach(function (i) { avail[i] = false; });
      total -= best.discount;
      winners.push(best);
    }
    return { total: total, winners: winners };
  }

  /* Slot dizisi kısa bir desenin tekrarıysa ([hoodie, kazak, cap] × 3) kişi
     başına parça sayısı; değilse 0. package-builder.js ile aynı çıkarım. */
  function groupSizeOf(pkg) {
    var handles = pkg.slots.map(function (s) { return s.collectionHandle; });
    var n = handles.length;
    for (var period = 2; period < n; period++) {
      if (n % period !== 0) { continue; }
      var repeats = true;
      for (var i = period; i < n; i++) {
        if (handles[i] !== handles[i % period]) { repeats = false; break; }
      }
      if (repeats) { return period; }
    }
    return 0;
  }

  /* Paketin koleksiyon → { count, price } dökümü, slot sırasıyla. */
  function slotTally(pkg) {
    var order = [];
    var map = {};
    pkg.slots.forEach(function (s) {
      var h = s.collectionHandle;
      if (!map[h]) { map[h] = { handle: h, count: 0, price: s.priceCents || 0 }; order.push(map[h]); }
      map[h].count++;
    });
    return { order: order, map: map };
  }

  function nounCount(count, handle) {
    return (count > 1 ? count + ' ' : '') + nounFor(handle);
  }

  function numberWord(n) {
    var words = String(tt('numberWords', 'Bir,İki,Üç,Dört,Beş,Altı')).split(',');
    return words[n - 1] || String(n);
  }

  function joinNouns(list) {
    if (list.length < 2) { return list.join(''); }
    return list.slice(0, -1).join(', ') + tt('and', ' ve ') + list[list.length - 1];
  }

  /* Kasım (tarih pencereli, endsAt'li) kombinler için iki öneri:
       lower   — bir parça eklemek sepet toplamını DÜŞÜRÜYORSA ("Bir cap
                 ekle, sepetin 950 TL azalsın"). Öneri motorunda 1. sıra.
       upgrade — tamamlanmış Kasım paketi, onu kapsayan bir üst Kasım
                 paketine büyüyebiliyorsa (İkili → Gardırop → Ekip).
                 Başka öneri yoksa çıkar (3. sıra). */
  function kasimLowerSuggestion(cart) {
    var base = cartUnits(cart);
    var now = simulate(base);
    var best = null;
    var tried = {};
    packages().forEach(function (pkg) {
      if (pkg.kind !== 'combo' || !pkg.slotMode || !pkg.endsAt) { return; }
      pkg.slots.forEach(function (slot) {
        var h = slot.collectionHandle;
        if (!slot.priceCents || tried[h]) { return; }
        tried[h] = true;
        var trial = simulate(base.concat([{ coll: h, price: slot.priceCents }]));
        var saving = now.total - trial.total;
        if (saving <= 0 || (best && saving <= best.saving)) { return; }
        var target = trial.winners.filter(function (w) {
          return w.pkg.kind === 'combo' && w.pkg.endsAt && w.units.indexOf(base.length) !== -1;
        })[0];
        if (!target) { return; }
        best = { kasim: 'lower', pkg: target.pkg, coll: h, saving: saving, before: now.total, after: trial.total };
      });
    });
    return best;
  }

  function kasimUpgradeSuggestion(completedRows) {
    var best = null;
    completedRows.forEach(function (row) {
      var from = row.pkg;
      if (!from.endsAt || !from.slotMode) { return; }
      var fromTally = slotTally(from);
      packages().forEach(function (to) {
        if (to === from || to.kind !== 'combo' || !to.slotMode || !to.endsAt) { return; }
        if (to.totalCents <= from.totalCents) { return; }
        var toTally = slotTally(to);
        var covers = fromTally.order.every(function (t) {
          return toTally.map[t.handle] && toTally.map[t.handle].count >= t.count;
        });
        if (!covers) { return; }
        if (best && to.totalCents >= best.pkg.totalCents) { return; }
        var extra = [];
        var extraCount = 0;
        var extraCents = 0;
        toTally.order.forEach(function (t) {
          var have = fromTally.map[t.handle] ? fromTally.map[t.handle].count : 0;
          var need = t.count - have;
          if (need > 0) {
            extra.push({ handle: t.handle, count: need });
            extraCount += need;
            extraCents += need * t.price;
          }
        });
        var toAnchor = toTally.order.reduce(function (sum, t) { return sum + t.count * t.price; }, 0);
        var group = groupSizeOf(to);
        best = {
          kasim: 'upgrade',
          pkg: to,
          from: row,
          extra: extra,
          extraCount: extraCount,
          extraCents: extraCents,
          keepCount: from.slots.length,
          plus: to.totalCents - from.totalCents,
          gain: (toAnchor - to.totalCents) - row.advantage,
          people: group ? to.slots.length / group : 0
        };
      });
    });
    return best;
  }

  function kasimDeadlineRow(completedRows) {
    var ends = 0;
    completedRows.forEach(function (row) {
      if (row.pkg.endsAt && (!ends || row.pkg.endsAt < ends)) { ends = row.pkg.endsAt; }
    });
    return ends ? { kasim: 'deadline', endsAt: ends } : null;
  }

  /* ----------------------------------------------------------
     Analiz + TEK ÖNERİ seçimi (öncelik motoru).

     Kural: "kazanılmış" durumlar (yeşil aktif kademe, tamamlanmış kombin
     satırı) HER ZAMAN görünür — bunlar onay, öneri değil. Öneri ise her
     sepette EN FAZLA BİR karttır. Seçim sırası:
       1. En az eksik ürün isteyen (en düşük sürtünme → en yüksek dönüşüm).
       2. Eşitlikte: müşteriye ek maliyeti SIFIR/negatif olan volume kademesi
          ("3 al 2 öde"nin bedava şapkası gibi) önce — ilan edilen kampanyayı
          kıl payı kala gizlemek marka dürüstlüğüne aykırı.
       3. Eşitlikte: markaya EK CİROSU en yüksek olan.
       4. Eşitlikte: volume, combo'dan önce (müşteri o kategoride zaten).

     Çifte sayım yok — GREEDY TAHSİS (2026-07-10, patron onayı:
     "kombin tamamsa onundur, tutarlılık daha iyi"):
     Üniteler, avantajı EN YÜKSEK hak sahibine sırayla tahsis edilir.
     Adaylar = tahsis edilmemiş ünitelerle TAMAMLANABİLEN kombinler +
     (avantajı > 0) ulaşılabilen hacim kademeleri. Her turda en yüksek
     avantajlı aday ünitelerini alır; eşitlikte KOMBİN hacimden önce
     gelir. Sonuçlar:
       - Tamamlanmış kombinin bileşeni başka hiçbir kartı beslemez
         (Daily Fit'in şapkası Cap Set'i saymaz/tetiklemez).
       - Sonradan eklenen ürün, daha yüksek avantajlı kurulu kombini
         ÇÖZEMEZ (Full Fit dururken 2. tee, 2'li kademeyi aktive edip
         Full Fit'i bölmez — kombin korunur, boştaki tee öneri besler).
       - Kurulu yüksek hacim kademesi de düşük avantajlı kombine
         bölünmez (3 tee + cap → 3'lü kalır, Daily Fit tee çalamaz).
     Aktif kademeli koleksiyonu paylaşan kombin ÖNERİLMEZ (indirim
     motorları çakışır). Markaya ek cirosu ≤ 0 olan kombin önerilmez
     (sepeti küçültür). cross_sell'i boş paket (Space Bag — kıtlık)
     sepette hiç önerilmez, yalnız tamamlanırsa onay satırı olur.
     ---------------------------------------------------------- */
  function analyze(cart) {
    var pkgs = packages();

    // satır başına kullanılabilir ünite (satır key'i → adet)
    var avail = {};
    cart.items.forEach(function (i) { avail[i.key] = i.quantity; });
    // checkout'un GERÇEK paket→satır tahsisi (Function kapalıysa boş)
    var allocByPkg = allocationsByPackage(cart);

    // 1) GREEDY TAHSİS — her turda, tahsis edilmemiş (avail) ünitelerle
    //    avantajı EN YÜKSEK hak sahibi (tamamlanabilen kombin VEYA
    //    ulaşılabilen hacim kademesi) ünitelerini alır; eşitlikte kombin
    //    kazanır ("kombin tamamsa onundur" — 2026-07-10 patron onayı).
    //    Kombin deneme sırası: çok slotlu önce, eşitlikte pahalı önce
    //    (Full Fit, Daily Fit'ten önce denenir). Paket başına TEK hak.
    var comboPkgs = pkgs.filter(function (p) { return p.kind === 'combo'; }).slice();
    comboPkgs.sort(function (a, b) {
      var as = a.slotMode ? a.slots.length : (a.components || []).length;
      var bs = b.slotMode ? b.slots.length : (b.components || []).length;
      if (as !== bs) { return bs - as; }
      return b.totalCents - a.totalCents;
    });
    var volPkgs = pkgs.filter(function (p) { return p.kind === 'volume' || p.kind === 'bxgy'; });

    var comboUsed = {};
    var completedRows = [];
    var claimed = {}; // pkg.handle → ünitelerini aldı
    var claims = {};

    for (;;) {
      var best = null;
      comboPkgs.forEach(function (pkg) {
        if (claimed[pkg.handle]) { return; }
        var r = analyzeCombo(pkg, cart, avail);
        if (!r || !r.complete) { return; }
        if (!best || r.advantage > best.adv) {
          best = { kind: 'combo', pkg: pkg, adv: r.advantage, row: r };
        }
      });
      volPkgs.forEach(function (pkg) {
        if (claimed[pkg.handle]) { return; }
        var p = volumeClaimProbe(pkg, cart, avail);
        if (!p || p.adv <= 0) { return; }
        // KESİN daha yüksek avantaj gerekir — eşitlikte kombin kazanır
        if (!best || p.adv > best.adv) {
          best = { kind: 'vol', pkg: pkg, adv: p.adv, take: p.take };
        }
      });
      if (!best) { break; }
      claimed[best.pkg.handle] = true;
      claims[best.pkg.handle] = {};
      if (best.kind === 'combo') {
        // collapse/kaldır/sayım hep GERÇEK indirim satırları üzerinden
        applyActualAllocation(best.row, allocByPkg);
        best.row.lines.forEach(function (x) {
          if (avail[x.line.key] > 0) { avail[x.line.key]--; }
          claims[best.pkg.handle][x.line.key] = (claims[best.pkg.handle][x.line.key] || 0) + 1;
          comboUsed[x.line.key] = (comboUsed[x.line.key] || 0) + 1;
        });
        completedRows.push(best.row);
      } else {
        best.take.forEach(function (u) {
          if (avail[u.line.key] > 0) { avail[u.line.key]--; }
          claims[best.pkg.handle][u.line.key] = (claims[best.pkg.handle][u.line.key] || 0) + 1;
        });
      }
    }

    // 2) tamamlanAMAyan kombinler KALAN üniteler üzerinden analiz edilir —
    //    kısmi kombin önerisi tahsis edilmiş üniteler üzerine kurulamaz.
    //    (avail yalnız küçüldüğü için burada tamamlanma ihtimali yok;
    //    satır ya kısmi ya null olur.)
    var comboRows = completedRows.slice();
    comboPkgs.forEach(function (pkg) {
      if (claimed[pkg.handle]) { return; }
      var r = analyzeCombo(pkg, cart, avail);
      if (r) { comboRows.push(r); }
    });

    // 3) volume SON geçişi: sayım = sepet − tamamlanmış kombin üniteleri
    //    (hacmin KENDİ rezervi sayımından düşülmez — kart kendi ünitelerini
    //    gösterir). Sepette yalnız tamamlanmış kombin varsa hacim kartı
    //    HİÇ çıkmaz — Daily Fit'in şapkası Cap Set kartını tetiklemez.
    var volRows = [];
    lastPackageUsed = {};
    var activeCollections = {};
    volPkgs.forEach(function (pkg) {
      var usedByOthers = {};
      cart.items.forEach(function (line) {
        var own = claims[pkg.handle] && claims[pkg.handle][line.key] || 0;
        usedByOthers[line.key] = line.quantity - (avail[line.key] || 0) - own;
      });
      lastPackageUsed[pkg.handle] = usedByOthers;
      var r = analyzeVolume(pkg, cart, usedByOthers);
      if (!r) { return; }
      volRows.push(r);
      if (r.active) { activeCollections[pkg.collectionHandle] = true; }
    });
    lastComboUsed = comboUsed;

    // 4) öneri adayları
    var candidates = [];
    volRows.forEach(function (r) {
      if (!r.next) { return; } // en üst kademe → salt onay
      candidates.push({
        row: r,
        kind: 'vol',
        missing: r.next.qty - r.count,
        incr: r.nextTotal - r.currentOutlay
      });
    });
    comboRows.forEach(function (r) {
      if (r.complete) { return; }
      if (r.pkg.suggest === false) { return; }
      var incr = r.pkg.totalCents - r.filledTotal;
      if (incr <= 0) { return; }
      if (r.slotMode) {
        var clash = r.pkg.slots.some(function (s) { return activeCollections[s.collectionHandle]; });
        if (clash) { return; }
      }
      candidates.push({ row: r, kind: 'combo', missing: r.missingCount, incr: incr });
    });
    candidates.sort(function (a, b) {
      if (a.missing !== b.missing) { return a.missing - b.missing; }
      var aFree = a.kind === 'vol' && a.incr <= 0;
      var bFree = b.kind === 'vol' && b.incr <= 0;
      if (aFree !== bFree) { return aFree ? -1 : 1; }
      if (a.incr !== b.incr) { return b.incr - a.incr; }
      if (a.kind !== b.kind) { return a.kind === 'vol' ? -1 : 1; }
      return 0;
    });
    var suggestion = candidates[0] || null;

    /* Kasım önerileri tek öneri kuralına girer: "ekle, sepetin azalsın"
       mevcut adaylardan önce, "bir üst paket" yalnız başka öneri yoksa. */
    var kasimSuggestion = kasimLowerSuggestion(cart);
    if (kasimSuggestion) {
      suggestion = null;
    } else if (!suggestion) {
      kasimSuggestion = kasimUpgradeSuggestion(completedRows);
    }

    // 5) render listesi: onaylar + (varsa) tek öneri
    var rows = [];
    var deadline = kasimDeadlineRow(completedRows);
    if (deadline) { rows.push(deadline); }
    comboRows.forEach(function (r) {
      if (r.complete) { rows.push(r); }
    });
    volRows.forEach(function (r) {
      var isSug = !!(suggestion && suggestion.kind === 'vol' && suggestion.row === r);
      r.isSuggestion = isSug;
      if (r.active || isSug) { rows.push(r); }
    });
    if (suggestion && suggestion.kind === 'combo') {
      suggestion.row.isSuggestion = true;
      rows.push(suggestion.row);
    }
    if (kasimSuggestion) { rows.push(kasimSuggestion); }
    return rows;
  }

  function compHtml(c) {
    var multi = c.variants.length > 1;
    var action;
    if (!c.variants.length) {
      action = '<span class="fos-cpk__soldout">' + tt('soldOut', 'Tükendi') + '</span>';
    } else if (c.variants.length === 1) {
      action = '<button type="button" class="fos-cpk__add" data-vid="' + c.variants[0].id + '">' + tt('add', 'Ekle') + '</button>';
    } else {
      action = '<span class="fos-cpk__sizes">' + c.variants.map(function (v) {
        return '<button type="button" class="fos-cpk__size" data-vid="' + v.id + '">' +
          (v.size === 'Default Title' ? tt('oneSize', 'Tek beden') : v.size) + '</button>';
      }).join('') + '</span>';
    }
    return '<div class="fos-cpk__miss' + (multi ? ' is-multi' : '') + '">' +
      '<span class="fos-cpk__miss-thumb">' + (c.image ? '<img src="' + c.image + '" alt="" width="44" height="44">' : '') + '</span>' +
      '<span class="fos-cpk__miss-name">' + c.title + '</span>' +
      '<span class="fos-cpk__miss-action">' + action + '</span>' +
    '</div>';
  }

  /* Tamamlanmış combo → tek "paket satırı" (collapse). data-keys =
     bu satırı oluşturan sepet SATIRLARININ key'leri (kaldırırken doğrudan
     bunlar sıfırlanır — pkg.components/slot bağımlılığı yok, hem sabit hem
     slot-bazlı combo için aynı çalışır). Variant id DEĞİL: aynı varyant
     sepette iki satırda durabiliyor, variant ile silmek paketin dışındaki
     satırı da götürüyordu. */
  function bundleLineHtml(r) {
    var lineKeys = r.lines.map(function (x) { return x.line.key; }).join(',');
    var thumbs = r.lines.map(function (x) {
      return '<span class="fos-cpk__bundle-thumb">' +
        (x.comp.image ? '<img src="' + x.comp.image + '" alt="">' : '') + '</span>';
    }).join('');
    var items = r.lines.map(function (x) {
      var vt = x.line.variant_title;
      var size = (vt && vt !== 'Default Title') ? ' (' + vt + ')' : '';
      return x.comp.title + size;
    }).join(' + ');
    var adv = r.advantage > 0
      ? '<span class="fos-cpk__adv">' + tt('advantage', '__AMOUNT__ avantaj', { AMOUNT: money(r.advantage) }) + '</span>' : '';
    /* Paket fiyatı = çapa − avantaj: gerçek tahsiste checkout'un TAM olarak
       bu satırlar için aldığı tutar (sezgisel yolda pkg.totalCents ile birebir
       aynı, çünkü avantaj = çapa − totalCents). */
    var total = r.anchor - r.advantage;
    var price = (r.anchor > total)
      ? '<span class="fos-cpk__bundle-anchor">' + money(r.anchor) + '</span>' +
        '<span class="fos-cpk__bundle-price">' + money(total) + '</span>'
      : '<span class="fos-cpk__bundle-price">' + money(total) + '</span>';
    return '<div class="fos-cpk__card fos-cpk__bundle">' +
      '<div class="fos-cpk__bundle-thumbs">' + thumbs + '</div>' +
      '<div class="fos-cpk__bundle-main">' +
        '<div class="fos-cpk__bundle-head">' +
          '<span class="fos-cpk__bundle-name">' + tt('bundleName', '__NAME__ PAKETİ', { NAME: r.pkg.name }) + '</span>' + adv +
        '</div>' +
        '<div class="fos-cpk__bundle-items">' + items + '</div>' +
        '<div class="fos-cpk__bundle-foot">' +
          '<span class="fos-cpk__bundle-prices">' + price + '</span>' +
          '<button type="button" class="fos-cpk__bundle-remove" data-keys="' + lineKeys + '">' + tt('remove', 'Kaldır') + '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function comboRowHtml(r) {
    if (r.collapsible) {
      return bundleLineHtml(r);
    }
    if (r.complete) {
      var advTxt = r.advantage > 0
        ? '<span class="fos-cpk__adv">' + tt('advantage', '__AMOUNT__ avantaj', { AMOUNT: money(r.advantage) }) + '</span>'
        : '';
      return '<div class="fos-cpk__card is-complete">' +
        '<span class="fos-cpk__badge">' + tt('packDone', 'PAKET TAMAM') + '</span>' +
        '<span class="fos-cpk__name">' + r.pkg.name + '</span>' +
        advTxt +
      '</div>';
    }
    if (r.slotMode) {
      // Eksik parçaları adıyla söyle: "Bir cap ekle → Daily Fit 1,950.00 TL"
      var nouns = r.slotResults
        .filter(function (s) { return !s.line; })
        .map(function (s) { return tt('oneNoun', 'bir __NOUN__', { NOUN: nounFor(s.slot.collectionHandle) }); })
        .join(' + ');
      var label = tt('addMissing', '__NOUNS__ ekle → __NAME__ __PRICE__', { NOUNS: nouns, NAME: r.pkg.name, PRICE: money(r.pkg.totalCents) });
      label = label.charAt(0).toUpperCase() + label.slice(1);
      return '<div class="fos-cpk__card is-partial">' +
        '<div class="fos-cpk__top"><span class="fos-cpk__kicker">' + r.pkg.name + '</span></div>' +
        '<div class="fos-cpk__sub">' + tt('completeCombo', 'KOMBİNİ TAMAMLA') + '</div>' +
        '<button type="button" class="fos-cpk__combo-complete" data-pkg="' + r.pkg.handle + '">' +
          '<span class="fos-cpk__tier-label">' + label + '</span>' +
        '</button>' +
      '</div>';
    }
    var pill = r.advantage > 0
      ? '<span class="fos-cpk__pill">' + tt('advantage', '__AMOUNT__ avantaj', { AMOUNT: money(r.advantage) }) + '</span>'
      : '';
    return '<div class="fos-cpk__card is-partial">' +
      '<div class="fos-cpk__top">' +
        '<span class="fos-cpk__kicker">' + r.pkg.name + '</span>' +
        pill +
      '</div>' +
      '<div class="fos-cpk__sub">' + tt('completePack', 'PAKETİ TAMAMLA') + '</div>' +
      r.missing.map(compHtml).join('') +
    '</div>';
  }

  /* Yemek-app tarzı kademeli ilerleme barı: maxQty segment, count kadarı dolu.
     Bir indirim kademesine ulaşıldıysa dolu segmentler yeşil, yoksa mavi. */
  function volBarHtml(count, maxQty, inDiscount) {
    var segs = '';
    var filled = Math.min(count, maxQty);
    for (var i = 0; i < maxQty; i++) {
      var cls = 'fos-cpk__seg';
      if (i < filled) { cls += inDiscount ? ' is-on is-won' : ' is-on'; }
      segs += '<span class="' + cls + '" style="--i:' + i + '"><i></i></span>';
    }
    return '<div class="fos-cpk__bar" aria-hidden="true">' + segs + '</div>';
  }

  var COLLECTION_NOUNS = I18N.nouns || {
    't-shirts': 't-shirt',
    'caps': 'cap',
    'hoodies': 'hoodie',
    'sweatshirts-hoodies': 'hoodie',
    'rotation-set': 'hoodie',
    'kazak': 'kazak',
    'socks': 'çorap',
    'canta': 'çanta'
  };
  function nounFor(handle) {
    return COLLECTION_NOUNS[handle] || tt('nounFallback', 'ürün');
  }

  function volumeRowHtml(r) {
    var p = r.pkg;
    var inDiscount = r.count >= r.firstQty; // en az bir indirim kademesi aktif

    /* Merdiven dili: yeşil bant = "şu an buradasın", mavi kutu = "bir adım
       sonrası". Emoji yok (sakin/premium ton), kutlamayı renk verir. */
    var won = '';
    if (inDiscount) {
      won = '<div class="fos-cpk__vol-won">' +
        (r.activeAdv > 0 ? tt('nowSaving', 'ŞU AN: __AMOUNT__ AVANTAJ', { AMOUNT: money(r.activeAdv) }) : tt('packActive', 'PAKET AKTİF')) +
      '</div>';
    }

    var top = '<div class="fos-cpk__vol-top">' +
        '<span class="fos-cpk__kicker">' + p.name + '</span>' +
        '<span class="fos-cpk__vol-count">' + Math.min(r.count, r.maxQty) + '/' + r.maxQty + '</span>' +
      '</div>';

    var bar = volBarHtml(r.count, r.maxQty, inDiscount);

    // CTA yalnız SEÇİLEN öneride: aktif ama önerilmeyen paket salt onay
    // olarak (yeşil bant + bar) kalır — tek öneri kuralı.
    var cta = '';
    if (!r.next) {
      cta = '<div class="fos-cpk__vol-max">' + tt('maxActive', 'EN BÜYÜK PAKET AKTİF') + '</div>';
    } else if (r.isSuggestion) {
      var left = r.next.qty - r.count;
      var noun = nounFor(p.collectionHandle);
      var label;
      var win = '';
      if (r.active && r.nextAdv > 0) {
        // kademe zaten aktif → "yükselme" dili: hedef avantaj + fark rozeti
        label = tt('tierUpgrade', '__N__ __NOUN__ daha → __AMOUNT__ avantaja yüksel', { N: left, NOUN: noun, AMOUNT: money(r.nextAdv) });
        var gain = r.nextAdv - r.activeAdv;
        if (gain > 0) { win = '<span class="fos-cpk__tier-win">+' + money(gain) + '</span>'; }
      } else {
        label = tt('tierAdd', '__N__ __NOUN__ daha ekle', { N: left, NOUN: noun });
        if (p.kind === 'bxgy') { win = '<span class="fos-cpk__tier-win">' + tt('bxgyNote', 'En uygun fiyatlı parça bizden') + '</span>'; }
        else if (r.nextAdv > 0) { win = '<span class="fos-cpk__tier-win">' + tt('advantagePlus', '+__AMOUNT__ avantaj', { AMOUNT: money(r.nextAdv) }) + '</span>'; }
      }
      var nextTag = r.active ? '<div class="fos-cpk__next-label">' + tt('nextStep', 'SONRAKİ ADIM') + '</div>' : '';
      cta = nextTag + '<button type="button" class="fos-cpk__tier" ' +
        'data-pkg="' + p.handle + '" data-qty="' + r.next.qty + '" data-total="' + r.nextTotal + '">' +
        '<span class="fos-cpk__tier-label">' + label + '</span>' +
        win +
      '</button>';
    }

    return '<div class="fos-cpk__card fos-cpk__vol ' + (inDiscount ? 'is-complete' : 'is-partial') + '">' +
      won + top + bar + cta +
    '</div>';
  }

  /* ----- Kasım kartları ----- */
  function kasimRowHtml(r) {
    if (r.kasim === 'deadline') {
      var end = new Date(r.endsAt);
      var day = end.toLocaleDateString(document.documentElement.lang || 'tr', { weekday: 'long', timeZone: 'Europe/Istanbul' });
      var time = end.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Istanbul' });
      var left = Math.max(0, r.endsAt - Date.now());
      var d = Math.floor(left / 86400000);
      var h = Math.floor((left % 86400000) / 3600000);
      return '<div class="fos-cpk__deadline">' +
        '<span class="fos-cpk__deadline-dot" aria-hidden="true"></span>' +
        '<span class="fos-cpk__deadline-text">' + tt('kasimDeadline', 'Kasım paketi fiyatı __DAY__ __TIME__\'a kadar', { DAY: day.charAt(0).toLocaleUpperCase('tr') + day.slice(1), TIME: time }) + '</span>' +
        '<span class="fos-cpk__deadline-left">' + tt('kasimLeft', '__D__g __H__s', { D: d, H: h }) + '</span>' +
      '</div>';
    }

    var name = r.pkg.name;
    if (r.kasim === 'lower') {
      var tally = slotTally(r.pkg).order.map(function (t) { return nounCount(t.count, t.handle); }).join(' + ');
      return '<div class="fos-cpk__card fos-cpk__kasim">' +
        '<div class="fos-cpk__top">' +
          '<span class="fos-cpk__kicker">' + tt('kasimOneLeft', '__NAME__ · 1 PARÇA KALDI', { NAME: name }) + '</span>' +
          '<span class="fos-cpk__tier-win">−' + money(r.saving) + '</span>' +
        '</div>' +
        '<div class="fos-cpk__kasim-title">' + tt('kasimLowerTitle', 'Bir __NOUN__ ekle, sepetin __AMOUNT__ azalsın.', { NOUN: nounFor(r.coll), AMOUNT: money(r.saving) }) + '</div>' +
        '<div class="fos-cpk__kasim-sub">' + tt('kasimLowerSub', '__ITEMS__ = __NAME__, __PRICE__. Sepetin şu an __NOW__, eklersen __AFTER__.', {
          ITEMS: tally, NAME: name, PRICE: money(r.pkg.totalCents), NOW: money(r.before), AFTER: money(r.after)
        }) + '</div>' +
        '<button type="button" class="fos-cpk__combo-complete fos-cpk__kasim-btn" data-pkg="' + r.pkg.handle + '">' +
          '<span class="fos-cpk__tier-label">' + tt('kasimPick', '__NOUN__ seç', { NOUN: nounFor(r.coll).charAt(0).toLocaleUpperCase('tr') + nounFor(r.coll).slice(1) }) + '</span>' +
        '</button>' +
      '</div>';
    }

    // upgrade
    var title = r.people > 1
      ? tt('kasimUpPeople', '__N__ kişi daha bul, __NAME__ olsun.', { N: numberWord(r.people - 1), NAME: name })
      : tt('kasimUpItems', '__ITEMS__ ekle, __NAME__ olsun.', {
          ITEMS: joinNouns(r.extra.map(function (e) { return e.count > 1 ? nounCount(e.count, e.handle) : tt('oneNoun', 'bir __NOUN__', { NOUN: nounFor(e.handle) }); })),
          NAME: name
        });
    title = title.charAt(0).toLocaleUpperCase('tr') + title.slice(1);
    var list = r.extra.map(function (e) { return e.count + ' ' + nounFor(e.handle); }).join(', ');
    var sub = tt('kasimUpSub', '__N__ parça daha: __LIST__. Tek tek __AMOUNT__.', { N: r.extraCount, LIST: list, AMOUNT: money(r.extraCents) });
    if (r.people > 1) {
      var per = Math.round(r.pkg.totalCents / r.people / 100) * 100;
      sub += ' ' + tt('kasimUpPer', 'Kişi başı __AMOUNT__\'ye iner.', { AMOUNT: money(per) });
    }
    var gain = r.gain > 0
      ? '<span class="fos-cpk__tier-win">' + tt('advantagePlus', '+__AMOUNT__ avantaj', { AMOUNT: money(r.gain) }) + '</span>'
      : '';
    return '<div class="fos-cpk__card fos-cpk__kasim">' +
      '<div class="fos-cpk__next-label">' + tt('kasimOneMore', 'BİR ADIM DAHA') + '</div>' +
      '<div class="fos-cpk__kasim-title">' + title + '</div>' +
      '<div class="fos-cpk__kasim-sub">' + sub + '</div>' +
      '<button type="button" class="fos-cpk__combo-complete fos-cpk__kasim-btn" data-pkg="' + r.pkg.handle + '">' +
        '<span class="fos-cpk__tier-label">' + tt('kasimUpCta', '__NAME__ olsun · +__AMOUNT__', { NAME: name, AMOUNT: money(r.plus) }) + '</span>' +
        gain +
      '</button>' +
      '<div class="fos-cpk__kasim-keep">' + tt('kasimKeep', 'Seçtiğin __N__ parça yerinde kalır.', { N: r.keepCount }) + '</div>' +
    '</div>';
  }

  function rowHtml(r) {
    if (r.kasim) { return kasimRowHtml(r); }
    return r.volume ? volumeRowHtml(r) : comboRowHtml(r);
  }

  function render(cart) {
    var content = document.querySelector(DRAWER_CONTENT);
    if (!content) {
      return;
    }
    // eski modülü temizle
    var old = content.querySelector('.fos-cart-pkgs');
    if (old) {
      old.parentNode.removeChild(old);
    }
    var rows = analyze(cart);
    if (!rows.length) {
      return;
    }
    injecting = true;
    var wrap = document.createElement('div');
    wrap.className = 'fos-cart-pkgs';
    wrap.innerHTML = rows.map(rowHtml).join('');
    content.insertBefore(wrap, content.firstChild);
    hideCollapsedLines(rows, cart);
    // self-mutation'ı yok say
    setTimeout(function () { injecting = false; }, 0);
  }

  /* Sepet sayfası (/cart): çekmecedeki paket göstergesi burada da çizilir,
     yoksa aynı sepetin iki görünümü farklı teşvik gösteriyordu. Sayfada
     ürün satırları zaten ayrı ayrı durduğu için tamamlanmış kombinin
     "paket satırı" (collapsible) çizilmez — satırı iki kez göstermiş oluruz. */
  var PAGE_MOUNT = '#fos-cart-page-pkgs';
  function renderPage(cart) {
    var mount = document.querySelector(PAGE_MOUNT);
    if (!mount) {
      return;
    }
    var rows = analyze(cart).filter(function (r) { return r.volume || !r.collapsible; });
    mount.innerHTML = rows.length ? '<div class="fos-cart-pkgs">' + rows.map(rowHtml).join('') + '</div>' : '';
  }

  function refreshPage() {
    window
      .fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderPage)
      .catch(function () {});
  }

  function watchPage() {
    if (!document.querySelector(PAGE_MOUNT)) {
      return;
    }
    refreshPage();
    // Adet değişince cart.js satırları section render ile yeniden basar.
    var items = document.getElementById('main-cart-items');
    if (items) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(refreshPage, 60);
      }).observe(items, { childList: true, subtree: true });
    }
    // Builder ya da "Ekle" sepete ürün koyunca satırlar sunucuda çizildiği
    // için sayfa yenilenir; çekmeceyi açmak burada bayat bir liste bırakırdı.
    document.addEventListener('cart:itemAdded', function () {
      window.location.reload();
    });
  }

  /* GoCart /cart.js sonucunu zaten biliyor. renderDrawerCart'ı sardığımızda
     paket kartlarını aynı veriyle, drawer açılmadan hemen önce çizeriz.
     MutationObserver + ikinci /cart.js isteği yalnız fallback olarak kalır. */
  var goCartHooked = false;
  function hookGoCart() {
    var instance = window.goCart;
    if (goCartHooked) {
      return true;
    }
    if (!instance || typeof instance.renderDrawerCart !== 'function') {
      return false;
    }
    var originalRenderDrawerCart = instance.renderDrawerCart;
    instance.renderDrawerCart = function (cart) {
      var result = originalRenderDrawerCart.call(this, cart);
      lastSig = cartSignature(cart);
      render(cart);
      return result;
    };
    goCartHooked = true;
    return true;
  }

  /* collapse: tamamlanmış combo bileşenlerinin GoCart satırlarını GİZLE
     (silmiyoruz — display:none, childList değil → observer tetiklenmez;
     GoCart her render'da satırları görünür kurar, biz yeniden gizleriz).
     Hedefleme SATIR SIRASI (data-line = cart.items index + 1) ile yapılır ve
     yalnız drawer içinde arar: variant seçicisi aynı varyantın ilk satırını
     bulup yanlış satırı (hatta mini cart'ınkini) gizleyebiliyordu. */
  function hideCollapsedLines(rows, cart) {
    rows.forEach(function (r) {
      if (r.volume || !r.collapsible) { return; }
      r.lines.forEach(function (x) {
        var pos = cart.items.indexOf(x.line) + 1;
        if (!pos) { return; }
        var single = document.querySelector(DRAWER_CONTENT + ' .go-cart-item__single[data-line="' + pos + '"]');
        if (single) { single.style.display = 'none'; }
      });
    });
  }

  function refreshCart(force) {
    window
      .fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sig = cartSignature(cart);
        var content = document.querySelector(DRAWER_CONTENT);
        var hasModule = content && content.querySelector('.fos-cart-pkgs');
        if (!force && sig === lastSig && hasModule) {
          return; // değişiklik yok, modül duruyor
        }
        lastSig = sig;
        render(cart);
      })
      .catch(function () {});
  }

  /* ----- ekle (eksik bileşen) ----- */
  function addVariant(vid, btn) {
    if (!vid || (btn && btn.classList.contains('is-loading'))) {
      return;
    }
    if (btn) { btn.classList.add('is-loading'); }
    window
      .fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) { btn.classList.remove('is-loading'); }
        if (!res.ok) {
          if (btn) {
            btn.classList.add('is-error');
            setTimeout(function () { btn.classList.remove('is-error'); }, 2000);
          }
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:itemAdded', { detail: res.data }));
        if (window.goCart && typeof window.goCart.fetchAndOpenCart === 'function') {
          window.goCart.fetchAndOpenCart();
        } else {
          refreshCart(true);
        }
      })
      .catch(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 2000);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fos-cpk__add, .fos-cpk__size');
    if (!btn) {
      return;
    }
    e.preventDefault();
    addVariant(parseInt(btn.getAttribute('data-vid'), 10), btn);
  });

  /* ----- volume kademe butonu → builder modalını aç ----- */
  function openVolumeBuilder(handle, qty, total) {
    var pkg = packages().filter(function (p) { return (p.kind === 'volume' || p.kind === 'bxgy') && p.handle === handle; })[0];
    if (!pkg || !window.fosBuilder || typeof window.fosBuilder.open !== 'function') {
      return;
    }
    window
      .fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = {};
        pkg.qualifyingIds.forEach(function (id) { ids[id] = true; });
        var locked = [];
        cart.items.forEach(function (i) {
          if (!ids[i.product_id]) { return; }
          // tamamlanmış bir kombine harcanan üniteler bu pakete kilitlenmez
          var used = lastPackageUsed[handle] || lastComboUsed;
          var q = i.quantity - (used[i.key] || 0);
          for (var k = 0; k < q; k++) {
            locked.push({
              product: { id: i.product_id, title: i.product_title || i.title, image: i.image },
              variant: { id: i.variant_id, size: i.variant_title || tt('oneSize', 'Tek beden'), price: i.price },
              inCart: true
            });
          }
        });
        // en az 1 slot seçilebilir kalsın (kademe butonu zaten qty>count için var)
        if (locked.length >= qty) {
          locked = locked.slice(0, qty - 1);
        }
        window.fosBuilder.open({
          qty: qty,
          totalCents: total,
          freeQuantity: (pkg.tiers.find(function (t) { return t.qty === qty; }) || {}).freeQuantity || 0,
          packageHandle: pkg.handle,
          collection: pkg.collectionHandle,
          excludeTags: pkg.excludeTags || [],
          locked: locked
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var tb = e.target.closest('.fos-cpk__tier');
    if (!tb) {
      return;
    }
    e.preventDefault();
    openVolumeBuilder(
      tb.getAttribute('data-pkg'),
      parseInt(tb.getAttribute('data-qty'), 10),
      parseInt(tb.getAttribute('data-total'), 10)
    );
  });

  /* ----- slot-bazlı combo "Kombini tamamla" → builder'ı sepetten aç ----- */
  function openComboBuilder(handle) {
    var pkg = packages().filter(function (p) { return p.kind === 'combo' && p.slotMode && p.handle === handle; })[0];
    if (!pkg || !window.fosBuilder || typeof window.fosBuilder.open !== 'function') {
      return;
    }
    window
      .fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Kasım yükseltmesinde kaynak paketin üniteleri de bu pakete gelir
        // ("seçtiğin parçalar yerinde kalır"); diğer tamamlanmış kombinlerin
        // üniteleri kilitlenmez. Aynı koleksiyondan iki slot (2 hoodie) aynı
        // satırın tek ünitesini iki kez kilitlemesin diye yerel sayaç.
        var used = pkg.endsAt ? {} : lastComboUsed;
        var taken = {};
        var slots = pkg.slots.map(function (slot) {
          var ids = {};
          slot.qualifyingIds.forEach(function (id) { ids[id] = true; });
          var lineMatches = cart.items.filter(function (i) {
            // tamamlanmış bir kombinin ünitesi başka kombinin slotunu dolduramaz
            return ids[i.product_id] && i.quantity - (used[i.key] || 0) - (taken[i.key] || 0) > 0;
          });
          // son eşleşen satır — analyzeComboSlots (ve Function) ile aynı seçim
          var line = lineMatches.length ? lineMatches[lineMatches.length - 1] : undefined;
          if (line) {
            taken[line.key] = (taken[line.key] || 0) + 1;
            return {
              collection: slot.collectionHandle,
              locked: {
                product: { id: line.product_id, title: line.product_title || line.title, image: line.image },
                variant: { id: line.variant_id, size: line.variant_title || tt('oneSize', 'Tek beden'), price: line.price },
                inCart: true
              }
            };
          }
          return { collection: slot.collectionHandle };
        });
        window.fosBuilder.open({
          totalCents: pkg.totalCents,
          packageHandle: pkg.handle,
          excludeTags: pkg.excludeTags || [],
          slots: slots
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var cb = e.target.closest('.fos-cpk__combo-complete');
    if (!cb) {
      return;
    }
    e.preventDefault();
    openComboBuilder(cb.getAttribute('data-pkg'));
  });

  /* ----- paket satırı "Kaldır" → o satırı oluşturan SATIRLARI sepetten çıkar.
     data-keys zaten render sırasında hesaplandı; pkg/slot arama gerekmez,
     hem sabit hem slot-bazlı combo için aynı çalışır.

     Satır key'i (variant id değil) tek satırı hedefler — aynı varyanttan
     ikinci bir satır varsa (paketin dışındaki tee'ler) o satır sepette kalır.

     TEK istek şart: satır key'i satırın indirim tahsisi değişince DEĞİŞİR
     (Shopify Cart API notu). Satırları sırayla silersek ilk silme paketin
     indirimini düşürür, kalan satırların key'i değişir ve sonraki istekler
     boşa düşer — sepette paketin yarısı kalır (2026-07-25'te canlıda
     görüldü). update.js hepsini aynı sepet durumuna karşı uygular. ----- */
  function removeBundle(keysCsv, btn) {
    var keys = (keysCsv || '').split(',').filter(function (s) { return s; });
    if (!keys.length || (btn && btn.classList.contains('is-loading'))) {
      return;
    }
    if (btn) { btn.classList.add('is-loading'); }
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    window
      .fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function (res) {
        if (!res.ok) { throw new Error('cart update failed'); }
        if (window.goCart && typeof window.goCart.fetchAndOpenCart === 'function') {
          window.goCart.fetchAndOpenCart();
        } else {
          refreshCart(true);
        }
      })
      .catch(function () {
        // sessiz başarısızlık olmasın: paket sepette kaldıysa müşteri görsün
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 2000);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var rb = e.target.closest('.fos-cpk__bundle-remove');
    if (!rb) {
      return;
    }
    e.preventDefault();
    removeBundle(rb.getAttribute('data-keys'), rb);
  });

  /* ----- drawer render'ını izle ----- */
  function watch() {
    var content = document.querySelector(DRAWER_CONTENT);
    if (!content) {
      return;
    }
    var t = null;
    var obs = new MutationObserver(function (list) {
      if (injecting) {
        return;
      }
      // yalnız bizim modülümüz eklendiyse atla
      var onlyOurs = list.every(function (m) {
        return Array.prototype.every.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && n.classList && n.classList.contains('fos-cart-pkgs');
        }) && m.removedNodes.length === 0;
      });
      if (onlyOurs) {
        return;
      }
      clearTimeout(t);
      t = setTimeout(function () { refreshCart(false); }, 60);
    });
    obs.observe(content, { childList: true, subtree: true });
    // GoCart henüz hazır değilse eski ağ tabanlı akış güvenli fallback.
    if (!hookGoCart()) {
      refreshCart(true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
    document.addEventListener('DOMContentLoaded', watchPage);
  } else {
    watch();
    watchPage();
  }
})();
